export default "__VITE_ASSET__BJKbj2KR__"